/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Update_PasswordInputs */

const en_update_password = /** @type {(inputs: Update_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update Password`)
};

const es_update_password = /** @type {(inputs: Update_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizar contraseña`)
};

const fr_update_password = /** @type {(inputs: Update_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mettre à jour le mot de passe`)
};

const de_update_password = /** @type {(inputs: Update_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passwort aktualisieren`)
};

const ja_update_password = /** @type {(inputs: Update_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パスワードを更新`)
};

const zh_update_password = /** @type {(inputs: Update_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新密码`)
};

const ar_update_password = /** @type {(inputs: Update_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تحديث كلمة المرور`)
};

const id_update_password = /** @type {(inputs: Update_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perbarui Kata Sandi`)
};

const it_update_password = /** @type {(inputs: Update_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiorna Password`)
};

const ru_update_password = /** @type {(inputs: Update_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обновить пароль`)
};

const pt_update_password = /** @type {(inputs: Update_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atualizar Senha`)
};

const ko_update_password = /** @type {(inputs: Update_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`비밀번호 업데이트`)
};

/**
* | output |
* | --- |
* | "Update Password" |
*
* @param {Update_PasswordInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const update_password = /** @type {((inputs?: Update_PasswordInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Update_PasswordInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_update_password(inputs)
	if (locale === "es") return es_update_password(inputs)
	if (locale === "fr") return fr_update_password(inputs)
	if (locale === "de") return de_update_password(inputs)
	if (locale === "ja") return ja_update_password(inputs)
	if (locale === "zh") return zh_update_password(inputs)
	if (locale === "ar") return ar_update_password(inputs)
	if (locale === "id") return id_update_password(inputs)
	if (locale === "it") return it_update_password(inputs)
	if (locale === "ru") return ru_update_password(inputs)
	if (locale === "pt") return pt_update_password(inputs)
	return ko_update_password(inputs)
});